module.exports = __webpack_public_path__ + "img/mobile_menu.117fd727.svg";